export default function ($translate) {
    return {
        KEYS: {
            FEED: 'FEED'
        },
        LABELS: {
            FEED: $translate.instant('notification.Feed')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/notification/transport/index.js